module.exports = __webpack_public_path__ + "static/media/icon-coin.cb9ac008.png";